/**
 * These errors can be reported by multiple
 * different types of actions but are handled in
 * different reducers.
 */

import {createAction} from '@reduxjs/toolkit';

export const unauthorizedUser = createAction('auth/unauthorizedUser');
